import type { JobsDashboardForm } from "./jobs-dashboard-form";
import type { JobsDashboardHandler } from "./jobs-dashboard-handler";

export class JobsDashboardListener {
    private readonly form: JobsDashboardForm;

    private readonly handler: JobsDashboardHandler;

    public constructor(form: JobsDashboardForm, handler: JobsDashboardHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.jobsDashboardBound === "1") {
            return;
        }
        root.dataset.jobsDashboardBound = "1";

        const refresh = this.form.getRefreshButton();
        if (refresh instanceof HTMLButtonElement) {
            refresh.addEventListener("click", () => {
                void this.handler.handleRefresh();
            });
        }

        const runAll = this.form.getRunAllButton();
        if (runAll instanceof HTMLButtonElement) {
            runAll.addEventListener("click", () => {
                void this.handler.handleRunAllClick();
            });
        }

        const list = this.form.getListEl();
        if (list instanceof HTMLElement) {
            list.addEventListener("click", (event) => {
                void this.handler.handleListClick(event as MouseEvent);
            });
        }
    }
}
